import React from 'react';
import { PricingPage as PricingPageComponent } from '../../components/pricing/PricingPage';
import { LandingHeader, LandingFooter } from '../../components/landing';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-white">
      <LandingHeader />
      <PricingPageComponent />
      <LandingFooter />
    </div>
  );
}
